import axiosInstance from 'api/axiosInstance';
import { CaseDeletabilityData } from 'api/cases/types';

/**
 * Deletability check for the guarded case-delete utility.
 * GET /api3.2/cases/:id/deletability (Node backend).
 * @param caseId - The case ID
 * @returns The deletability payload (backend plan §2 contract)
 * @throws AxiosError - callers surface error.response?.data?.error?.message
 */
const getCaseDeletability = async (
  caseId: number,
): Promise<CaseDeletabilityData> => {
  try {
    const { data } = await axiosInstance.get(
      `/api3.2/cases/${caseId}/deletability`,
    );
    return data.data as CaseDeletabilityData;
  } catch (error) {
    console.error('[getCaseDeletability] Failed:', error);
    throw error;
  }
};

export default getCaseDeletability;
